<template>
  <div style="position:sticky;top:0;z-index:2">

  <b-navbar toggleable="lg" type="dark" variant="info" >

    <b-navbar-toggle target="nav-collapse" ></b-navbar-toggle>
    <b-navbar-nav class="ml-auto search-contaier">
      <div class="d-flex">
        <router-link :to="{name:'shoppingcard'}" class="order-1 mr-auto">
          <div class="xs-card" id="shopcard2">
            <span class="count" v-if="cart.length">{{cart.length}}</span>
              <font icon="shopping-cart"/>
          </div>
        </router-link>
        <b-navbar-brand to="/">
          <b-img fluid src="https://cdn.salla.sa/yPZz/FsVxnxzElu5SjmBV1Y5t3jTbDX8ivgvRsAma25g0.jpeg"></b-img>
        </b-navbar-brand>
        <!-- <b-navbar-brand to="/">
          <b-img height="50" fluid src="https://offers-jo.easysooq.net/images/logo/fav.png"></b-img>
        </b-navbar-brand> -->
      </div>

    </b-navbar-nav>


    <b-navbar-nav class="ml-auto search-container d-none d-sm-block" >
      <b-nav-form class="search-box">
        <b-form-input size="sm" class="mr-sm-2" placeholder="ابحث عما تريد"></b-form-input>
        <font icon="search" class="search-box"/>
      </b-nav-form>
    </b-navbar-nav>
    <!-- <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto search-container">
        <b-nav-form class="search-box">
          <b-form-input size="sm" class="mr-sm-2" placeholder="ابحث عما تريد"></b-form-input>
          <font icon="search" class="search-box"/>
        </b-nav-form>
      </b-navbar-nav>
    </b-collapse> -->

    <b-collapse id="nav-collapse" is-nav class="lg-card">
      <b-navbar-nav class="ml-auto" >
        <router-link :to="{name:'shoppingcard'}">
          <b-row class="card-box d-none d-sm-flex" id="shopcard">
            <b-col cols="3" class="card-icon">
              <font icon="shopping-cart"/>
            </b-col>
            <b-col cols="9" class="content ">
              <div>
                  سلة المشتريات
              </div>
              <div>
                {{cart.length}} منتج  -  {{priceOfCart}} دينار
              </div>
            </b-col>
          </b-row>
        </router-link>
      </b-navbar-nav>
    </b-collapse>
    <!--mobile nav bar-->
    <b-collapse id="nav-collapse" class="sub-nav d-sm-none m-0" style="height:0" is-nav >
      <b-navbar-nav>
         <b-nav-item
         class="d-sm-none"
         v-for="cat in staticCategories"
         :key="cat.cat_icon_path"
         :to="{name:'Category', params:{name:cat.cat_name, id:cat.id}}">
           {{cat.cat_name}}
         </b-nav-item>

       </b-navbar-nav>

    </b-collapse>

    <!--desktop nav bar-->


  </b-navbar>
  <!--slider-->
    <div class="slider-container d-none d-sm-block" @mouseenter="mouseIsOver = true" @mouseleave="mouseIsOver = false">
      <b-container>
        <div>
          <swiper class="pb-1" ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="cat in staticCategories"  :key="cat.cat_icon_path">
              <b-nav-item class="text-center" :class="{'active': routeName == cat.cat_name}"   :to="{name:'Category', params:{name:cat.cat_name, id:cat.id}}"> {{cat.cat_name}}</b-nav-item>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
    </b-container>
    </div>
  </div>
</template>

<script type="text/javascript">
import {mapState, mapActions} from "vuex"
import axios from "axios"
import { Swiper, SwiperSlide, directive, Autoplay } from 'vue-awesome-swiper'
Swiper.use([Autoplay]);
import 'swiper/swiper.min.css'
  export default {
    name :'navbar',
    components: {
      Swiper,
      SwiperSlide
    },
    directives: {
      swiper: directive
    },
    data() {
      return {
        mouseIsOver:false,
        swiperOptions: {
  
          slidesPerView:6,
          loop:true,
        autoplay: true,
          pagination: {
            el: '.swiper-pagination'
          },
          // Some Swiper option/callback...
        },
        staticCategories:{
          "0":{id:"1","cat_name":"عروض جديدة","cat_icon_path":"images/categories/50c7b2ec64298545d62c5a49d3de97d9.png","cat_banner_path":"images/categories/banners/default_banner.png"},
          "1":{id:"5","cat_name":"منتجات بـ 5 دنانير وأقل","cat_icon_path":"images/categories/db9576b73a84210053fe6557f0f91359.png","cat_banner_path":"images/categories/banners/5fedec9bcbb5ceff33b5c6ca4fc4d52d.png"},
          "2":{id:"7","cat_name":"أدوات مطبخ","cat_icon_path":"images/categories/6197516e179f77e1289b831f5a4935db.png","cat_banner_path":"images/categories/banners/default_banner.png"},
          "3":{id:"8","cat_name":"مستلزمات نسائية","cat_icon_path":"images/categories/7085d9549b38d6f9e717f033aceb3053.png","cat_banner_path":"images/categories/banners/default_banner.png"},
          "4":{id:"9","cat_name":"مستلزمات رجالية","cat_icon_path":"images/categories/dbc3c6cdaf3431dac3e9774365b688b8.png","cat_banner_path":"images/categories/banners/default_banner.png"},
          "5":{id:"10","cat_name":"الكترونيات","cat_icon_path":"images/categories/5b5077b8dc7e2e167f48d7f71aa77639.png","cat_banner_path":"images/categories/banners/default_banner.png"},
          "6":{id:"11","cat_name":"مستلزمات طبية","cat_icon_path":"images/categories/7c65d281afd53bb79cdca3a58b1c7ba4.png","cat_banner_path":"images/categories/banners/default_banner.png"},
          "7":{id:"12","cat_name":"ادوات منزلية","cat_icon_path":"images/categories/f1fb227635e1a798ea5e8981e0b1ccb7.png","cat_banner_path":"images/categories/banners/3601eede3a94d3a2c6baf30a9405ef59.jpg"},
          "8":{id:"13","cat_name":"مشدات","cat_icon_path":"images/categories/a8b1e6c21debcbe28fadf6f26853ab56.jpg","cat_banner_path":"images/categories/banners/default_banner.png"},
          "9":{id:"14","cat_name":"بكجات ايزي سوق","cat_icon_path":"images/categories/898952c04286e433743d358f2a2d05c2.png","cat_banner_path":"images/categories/banners/default_banner.png"},
          "10":{id:"16","cat_name":"مستلزمات السيارة","cat_icon_path":"images/categories/55750dca2f0b720b39060e81d49ee8fc.jpg","cat_banner_path":"images/categories/banners/default_banner.png"},
          "11":{id:"17","cat_name":"أدوات صناعية","cat_icon_path":"images/categories/dba4c54edfcd006be42059aead61c80b.png","cat_banner_path":"images/categories/banners/default_banner.png"},
          "12":{id:"18","cat_name":"اكسسوارات هواتف","cat_icon_path":"images/categories/7c628a82d68971af7b8420bb75d1ed7e.png","cat_banner_path":"images/categories/banners/default_banner.png"},
          "13":{id:"19","cat_name":"BlackFriday SALE","cat_icon_path":"images/categories/97848e7f960c1e90313a68ae523bac13.png","cat_banner_path":"images/categories/banners/94999c91945b61330f2f1a57d3301a11.jpg"}
          },
        showSub:true,
        showSearch:false,
        scrolled:'',
        showNav:true,
        slideToNumber:0,
        window: {
            width: 0,
            height: 0
        }
      }
    },
    computed:{
      ...mapState(["categories", "cart"]),
      routeName() {
        return this.$route.params.name 
      },
      priceOfCart() {
        if(this.cart) {
          let price = 0;
          for(let i of this.cart) {
            price += Number(i.selling_price)
          }
          return price
        }
      },
      swiper() {
        
        return this.$refs.mySwiper.$swiper
      }
    },
    watch: {

      'scrolled' : function() {
        var vm = this
        if(this.window.width > 991 && this.scrolled) {

          setTimeout(function(){
            vm.showSub = false;
          }, 100);
        } else if (this.window.width > 991 && !this.scrolled) {
          setTimeout(function(){
            vm.showSub = true;
          }, 100);
        }
        if(this.window.width < 991 && this.scrolled) {
          setTimeout(function(){
            vm.showSearch = true;
          }, 100);
        } else if (this.window.width < 991 && !this.scrolled) {
          setTimeout(function(){
            vm.showSearch = false;
          }, 100);
        }
      }

    },
    created() {
        window.addEventListener('resize', this.handleResize);
        // window.addEventListener('scroll', this.handleScroll);
        this.handleResize();
        //this.swiper.slideTo(1, 100, false)

        //this.getCategories();
        setInterval(()=>{
          if(this.slideToNumber > Object.keys(this.staticCategories).length) {
            this.slideToNumber = 0
          }
          if(!this.mouseIsOver) {
            this.slideToNumber ++ 
            this.swiper.slideTo(this.slideToNumber, 500, false)
          }

        },5000)
    },
    mounted() {
      //this.getCategories();
      this.getCardItems();
      this.$refs.mySwiper.$swiper.slideTo(1, 500, false)
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
       ...mapActions(["getCardItems"]),
      //get categories
      getCategories() {
        let i = new FormData();
        i.append("action", "get_categories")
        axios.post(``,i)
        .then(res=>{
          this.categories = res.data
        })
      },
      handleResize() {
          this.window.width = window.innerWidth;
          this.window.height = window.innerHeight;
      },
      handleScroll () {
        this.scrolled = window.scrollY > 0;
      }
    },

  }
</script>
<style media="screen">
@charset "UTF-8";

/*!
* animate.css -http://daneden.me/animate
* Version - 3.5.1
* Licensed under the MIT license - http://opensource.org/licenses/MIT
*
* Copyright (c) 2016 Daniel Eden
*/

.animated {
-webkit-animation-duration: 1s;
animation-duration: 1s;
-webkit-animation-fill-mode: both;
animation-fill-mode: both;
}

.animated.infinite {
-webkit-animation-iteration-count: infinite;
animation-iteration-count: infinite;
}

.animated.hinge {
-webkit-animation-duration: 2s;
animation-duration: 2s;
}

.animated.flipOutX,
.animated.flipOutY,
.animated.bounceIn,
.animated.bounceOut {
-webkit-animation-duration: .75s;
animation-duration: .75s;
}

@-webkit-keyframes bounce {
from, 20%, 53%, 80%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}

40%, 43% {
  -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  -webkit-transform: translate3d(0, -30px, 0);
  transform: translate3d(0, -30px, 0);
}

70% {
  -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  -webkit-transform: translate3d(0, -15px, 0);
  transform: translate3d(0, -15px, 0);
}

90% {
  -webkit-transform: translate3d(0,-4px,0);
  transform: translate3d(0,-4px,0);
}
}

@keyframes bounce {
from, 20%, 53%, 80%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}

40%, 43% {
  -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  -webkit-transform: translate3d(0, -30px, 0);
  transform: translate3d(0, -30px, 0);
}

70% {
  -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  -webkit-transform: translate3d(0, -15px, 0);
  transform: translate3d(0, -15px, 0);
}

90% {
  -webkit-transform: translate3d(0,-4px,0);
  transform: translate3d(0,-4px,0);
}
}

.bounce {
-webkit-animation-name: bounce;
animation-name: bounce;
-webkit-transform-origin: center bottom;
transform-origin: center bottom;
}



</style>
